import React, {memo} from 'react'
import { Checkbox, FormControlLabel } from '@material-ui/core';

const AppCheckbox = memo(
    ({
         
         id,
         name,
         label,
         value = '',
         checked,
         required = false,
         disabled = false,
         onChange,
     }) => {

        let style = {};

        return (
            <FormControlLabel
                control={
                    <Checkbox
                        id={id}
                        name={name}
                        label={label}
                        value={value}
                        checked={checked}
                        required={required}
                        onChange={onChange}
                        style={style}
                        disabled={disabled}
                    />
                }
                label={label}
            />
        );

    });
export default AppCheckbox
